<div class="modal-header">
    <div class="d-flex w-100 align-items-center">
        <div class="flex-grow-1">
            <h4 class="modal-title">
                Opret synkroniseringskontrakt for
                @if(customerIdWasPreset() && customer().name) {
                <span class="text-nowrap">{{ customer().name }} - [{{ customer().customerId}}]</span>
                } @else if (!customerIdWasPreset() && selectedDepartment().name) {
                afdeling <span class="text-nowrap">{{ selectedDepartment().name }} - [{{ selectedDepartment().code}}]</span>
                } @else {
                <i class="fa-solid fa-spinner-third fa-spin ms-1"></i>
                }
            </h4>
        </div>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
    </div>
</div>

<div class="modal-body">
    @if (saving()) {
    <div class="d-flex flex-column justify-content-center align-items-center w-100 vh-50">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">Opretter synkroniseringskontrakt</h4>
    </div>
    } @else {
    @if (!customerIdWasPreset()) {
    <div class="mb-3">
        <div class="form-floating">
            @if (customersResource.isLoading()) {
            <div class="form-control text-center">
                <i class="fa-solid fa-spinner-third fa-spin"></i>
            </div>
            } @else {
            <select class="form-select" id="customer-select" [(ngModel)]="selectedCustomerId" name="customer">
                <option [value]="null" disabled>Vælg kunde</option>
                @for (customer of customers(); track $index) {
                <option [value]="customer.customerId">{{ customer.name }} - {{ customer.customerId }}</option>
                }
            </select>
            }
            <label for="customer-select">Kunde</label>
        </div>
    </div>
    }

    <div class="mb-3">
        <div class="form-floating">
            @if (companiesResource.isLoading()) {
            <div class="form-control text-center">
                <i class="fa-solid fa-spinner-third fa-spin"></i>
            </div>
            } @else if (companies().length === 0) {
            <input type="text" class="form-control" id="no-companies-available" disabled
                value="Ingen regnskaber for den valgte kunde">
            } @else {
            <select class="form-select" id="company-select" [disabled]="lockCompanySelection()"
                [(ngModel)]="selectedCompanyId" name="company">
                @for (company of companies(); track $index) {
                <option [value]="company.companyId">{{ company.name }} - {{ company.companyId }}</option>
                }
            </select>
            }
            <label for="company-select">Regnskab</label>
        </div>
    </div>

    <div class="mb-3">
        <div class="form-floating">
            <input type="text" class="form-control" id="synchronization-name" [(ngModel)]="name" name="syncnavn"
                autocomplete="off" autofocus>
            <label for="synchronization-name">Synkroniseringsnavn (valgfrit)</label>
        </div>
    </div>
    }
</div>

<div class="modal-footer">
    <button class="btn btn-success" [disabled]="!canSave()" (click)="createSync()">
        Opret synkroniseringskontrakt
    </button>
</div>